import { LANGUAGE_DE, LANGUAGE_FR } from 'shared/consts'
import {
  TENANT_AT,
  TENANT_CH,
  TENANT_COM,
  TENANT_FR,
  TENANT_IT,
} from 'shared/consts/tenants'
import {
  type ExperimentName,
  PDP_APP_BANNER,
  PDP_APP_BANNER_AT,
  PDP_APP_BANNER_CH,
  PDP_APP_BANNER_FR,
  PDP_APP_BANNER_IT,
} from 'shared/experiments/consts'
import { event as e } from 'shared/experiments/utils/event'

export const BANNER_EVENT = 'af_banner'

export const EVENT_CLICK_CTA = e`AppsFlyer - CTA click`
export const EVENT_CLICK_CLOSE = e`AppsFlyer - Close icon click`

export const BANNER_KEYS: Record<string, string> = {
  [TENANT_COM]: 'eef8ccbe-6809-43a5-b3f8-c15c312f2e88',
  [TENANT_AT]: '08109d36-f5de-4784-9372-25dc3aa82b04',
  [TENANT_IT]: '3f11c42a-6433-48ba-84ea-be812d219661',
  [TENANT_FR]: '69e0b860-b10e-4040-a6b1-61db293d941c',
  [`${TENANT_CH}-${LANGUAGE_DE}`]: '518c1523-2474-4737-a5b9-af6919e3dbe7',
  [`${TENANT_CH}-${LANGUAGE_FR}`]: 'b2e1de3d-50b5-4260-94e8-4ea147982d7f',
}

export const EXPERIMENT_TENANT: Record<string, ExperimentName> = {
  [TENANT_COM]: PDP_APP_BANNER,
  [TENANT_AT]: PDP_APP_BANNER_AT,
  [TENANT_IT]: PDP_APP_BANNER_IT,
  [TENANT_FR]: PDP_APP_BANNER_FR,
  [`${TENANT_CH}-${LANGUAGE_DE}`]: PDP_APP_BANNER_CH,
  [`${TENANT_CH}-${LANGUAGE_FR}`]: PDP_APP_BANNER_CH,
}
